import { FC, ReactNode } from 'react'
import {
  BorderRadius6,
  GreyGrey10,
  GreyGrey60,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular,
  Box,
  Flex
} from '@sequencehq/core-components'
import { Button, useModalState } from '@sequencehq/core-components'
import { capitalize } from 'inflection'

export const LinkEntity: FC<{
  'data-testid'?: string
  serviceName: string
  externalEntityLabel: string
  sequenceEntityLabel: string
  linkModal?: (modalProps: { onClose: () => void }) => ReactNode
  canLink?: boolean
  text?: string
  showLinkButton?: boolean
}> = ({ showLinkButton = true, ...props }) => {
  const testIdPrefix = props['data-testid'] || 'linkEntity'
  const { isModalOpen, openModal, closeModal } = useModalState()

  return (
    <Flex
      padding="12px"
      flexDirection="column"
      gap="4px"
      backgroundColor={GreyGrey10}
      borderRadius={BorderRadius6}
      alignItems="flex-start"
    >
      <Box
        {...Primary13SemiBold}
        color={GreyGrey80}
        data-testid={`${testIdPrefix}.noLinkTitle`}
      >
        {capitalize(`No ${props.externalEntityLabel} to show`)}
      </Box>
      <Box
        {...Primary13Regular}
        color={GreyGrey60}
        marginBottom="4px"
        data-testid={`${testIdPrefix}.noLinkText`}
      >
        {props.text ??
          `This ${props.sequenceEntityLabel.toLowerCase()} is not linked to a ${props.serviceName} ${props.externalEntityLabel.toLowerCase()} yet.`}
      </Box>
      {showLinkButton && (
        <Box width="100%">
          <Button
            data-testid={`${testIdPrefix}.linkButton`}
            variant="secondary"
            style={{ width: '100%' }}
            disabled={props.canLink === false}
            onClick={openModal}
          >
            Link {props.externalEntityLabel.toLowerCase()}
          </Button>
          {isModalOpen && props.linkModal?.({ onClose: closeModal })}
        </Box>
      )}
    </Flex>
  )
}
